import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';
import MaterialGrid from '@material-ui/core/Grid';
import PrimaryButton from 'common/components/buttons/primaryButton';
import SecondaryButton from 'common/components/buttons/secondaryButton';
import { InputLabelOutlined } from 'common/components/fields/InputLabelOutlined';
import LoadingProgress from 'common/components/progress/loading';
import { FORM_RULES } from 'helpers/validations';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Field, Form, getFormValues, reduxForm } from 'redux-form';
import GenericConfirmationCard from 'common/components/cards/genericConfirmationModel/genericConfirmationModel';
import { isMobile } from 'react-device-detect';
import { getList as getCategoriesList } from '../../../categories/categoriesActions';
import { getGroupingsStationId } from '../../groupings/groupingsActions';

class Interaction extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openConfirmation: false,
    };
    this.props.getCategoriesList(this.props.auth.user.establishments[0].stations[0].id);
    this.props.getGroupingsStationId(this.props.auth.user.establishments[0].stations[0].id);
  }

  onSubmit = (values) => {
    if (values.isFree) {
      values.price = 0.0;
      values.newPrice = 0.0;
    }
    values.categories = values.categories_field.map((item) => item.id);
    values.groupings = values.groupings_field.map((item) => item.id);
    values.submitFromButton = true;
    this.props.onClickProgress(values);
  };

  onSubmitSec = (values) => {
    if (values.isFree) {
      values.price = 0.0;
      values.newPrice = 0.0;
    }
    values.categories = values.categories_field.map((item) => item.id);
    values.groupings = values.groupings_field.map((item) => item.id);
    values.submitFromButton = true;
    this.props
      .onClickProgress(values)
      .then(() => {
        this.props.closeModal();
      })
      .catch(() => {});
  };

  render() {
    const atividade = this?.props?.formValues;
    const now = new Date();
    const isDisabled = !atividade?.is_draft && now > new Date(atividade?.end);
    return this.props.shareContent.loading ? (
      <div className="d-flex justify-content-center mt-5">
        <LoadingProgress />
      </div>
    ) : (
      <>
        <Form role="form" onSubmit={this.props.handleSubmit(this.onSubmit)} noValidate>
          <div
            style={{
              overflowY: 'scroll',
              height: isMobile ? 'calc(100vh - 250px)' : 'calc(100vh - 355px)',
              overflowX: 'hidden',
              paddingRight: isMobile ? 0 : 15,
            }}>
            <MaterialGrid container spacing={3}>
              <MaterialGrid item xs={12}>
                <Typography>
                  A estrutura a ser compartilhada é: Texto + (Quebra de linha) + link
                </Typography>
              </MaterialGrid>
              <MaterialGrid item xs={12}>
                <Field
                  component={InputLabelOutlined}
                  label={`Texto`}
                  name={`share_content_text`}
                  validate={[FORM_RULES.required]}
                  required
                  margin="normal"
                  disabled={this.props.router.params.action === 'proposta'}
                />
              </MaterialGrid>
              <MaterialGrid item xs={12}>
                <Field
                  component={InputLabelOutlined}
                  label={`Link`}
                  name={`share_content_link`}
                  validate={[FORM_RULES.required]}
                  required
                  margin="normal"
                  disabled={this.props.router.params.action === 'proposta'}
                />
              </MaterialGrid>
            </MaterialGrid>
            <GenericConfirmationCard
              open={this.props.openConfirmation}
              cancelClose={this.props.handleCancelClose}
              maxWidthFixed
              labelLeftButton={'Continuar aqui'}
              labelRightButton={this.props.buttonConfirmationLabel}
              general={this.props.general}
              confirmButtonColor={'primary'}
              title={this.props.confirmationTitle}
              text={this.props.confirmationSubtitle}
              onClose={() => this.props.setOpenConfirmation(false)}
              onClick={() => this.props.router.push('/owner/acoes/minhas-atividades')}
            />
          </div>
          <MaterialGrid
            container
            display="flex"
            justify="space-around"
            alignItems="center"
            style={{
              margin: '25px 0px',
              overflowX: 'hidden',
              paddingRight: isMobile ? 0 : 29,
            }}>
            <SecondaryButton
              type="button"
              color="secondary"
              onClick={this.props.prevClick}
              // progress={parseInt(this.props.general.submitProgress)}
              style={{
                margin: 0,
                width: '48%',
                padding: '10px 20px',
                textTransform: 'none',
              }}>
              Voltar
            </SecondaryButton>
            <PrimaryButton
              type="submit"
              disabled={this.props.activeActions.buttonLoading || isDisabled}
              color="primary"
              // proress={parseInt(this.props.general.submitProgress)}
              style={{
                margin: 0,
                width: '48%',
                padding: isMobile ? '12px 20px' : '10px 20px',
                textTransform: 'none',
                fontSize: isMobile ? 12 : undefined,
              }}>
              Salvar e continuar
            </PrimaryButton>
          </MaterialGrid>
        </Form>
      </>
    );
  }
}

Interaction.propTypes = {
  activeActions: PropTypes.shape({
    buttonLoading: PropTypes.any,
  }),
  auth: PropTypes.shape({
    user: PropTypes.shape({
      establishments: PropTypes.any,
    }),
  }),
  buttonConfirmationLabel: PropTypes.any,
  closeModal: PropTypes.func,
  confirmationSubtitle: PropTypes.any,
  confirmationTitle: PropTypes.any,
  general: PropTypes.any,
  getCategoriesList: PropTypes.func,
  handleCancelClose: PropTypes.any,
  handleSubmit: PropTypes.func,
  onClickProgress: PropTypes.func,
  openConfirmation: PropTypes.any,
  prevClick: PropTypes.any,
  router: PropTypes.shape({
    params: PropTypes.shape({
      action: PropTypes.string,
    }),
    push: PropTypes.func,
  }),
  setOpenConfirmation: PropTypes.func,
  shareContent: PropTypes.shape({
    loading: PropTypes.any,
  }),
};

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    shareContent: state.shareContent,
    categories: state.categories,
    groupings: state.groupings.list,
    activeActions: state.activeActions,
    general: state.general,
    formValues: getFormValues('shareContentForm')(state),
  };
};
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getCategoriesList,
      getGroupingsStationId,
    },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  reduxForm({
    form: 'shareContentForm',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
  })(Interaction)
);
